import styled, {css} from 'styled-components';
import { device } from '../../themes/Breakpoints';

export const Wrapper = styled.section`
	padding: 0 20px;
	width: 100%;
	height: 100%;
  
`;

export const RankingsWrapper = styled.div`
	width: 100%;
	height: 100%;
	margin-top: 4%;
	background: #fff;
	border-radius: 10px;
	padding: 0 24px;
    margin-bottom: 40px;
	.rankingTitle {
		margin-bottom: 0px;
        padding-top: 40px;
	}
  @media only screen and (max-width: 767px) {
    padding: 0 12px;
  }
`;

export const SubTitle = styled.div`
	margin-top: 16px;
	p {
		color: #3e464f;
		font-size: 24px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}
  @media only screen and (max-width: 767px) {
    margin-top: 8px;
  }
  p {
    font-size: 20px;
    line-height: 28px
  }
`;

export const UserInfo = styled.div`
	p,
	span {
		color: #9ba1a7;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		margin-top: 40px;
	}
  @media only screen and (max-width: 767px) {
    p,
    span {
      margin-top: 12px;
    }
  }
`;

export const DividerLine = styled.div`
	width: 100%;
	background-color: #d4d4d4;
	height: 1px;
	margin-top: ${props => (props.$mt ? `${props.$mt}` : '0px')};
	margin-bottom: ${props => (props.$mb ? `${props.$mb}` : '0px')};
`;

export const RankingsHeader = styled.div`

`;

export const RankPlayersWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 40px;
	.column-div{
	width: 45%
	}
	.ranking-action {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 24px;
		margin-top: 80px;
       padding-bottom: 40px;
		.disable {
			opacity: 0.5;
			pointer-events: none;
		}
		.remove {
			display: flex;
			align-items: center;
			color: #e74c3c;
			font-size: 19px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			gap: 6px;
			cursor: pointer;
		}
		a,
		.save {
			display: inline-flex;
			padding: 9px 24px;
			align-items: center;
			gap: 10px;
			flex-shrink: 0;
			border-radius: 3px;
			background: #004ea3;
			width: fit-content;
			color: #fff;
			font-size: 19px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			cursor: pointer;
		}
	}
	.ranking-players {
		width: 100%;
		margin-top: 50px;
	}
	.ghost {
		background: lightblue;
	}
	.handle {
		cursor: grab;
	}
	.player-item.selected {
		background-color: rgba(0, 123, 255, 0.3); /* Add a background to indicate selection */
	}
	
	.editIcon {
		cursor: pointer;
		&:hover {
			opacity: 0.8;
		}
	}
	.ranking {
		&-setting {
			display: flex;
			gap: 32px;
		}
	}
	.flexColumn {
		display: flex;
		flex-direction: column;
		gap: 4px;
		input#numberPlayers {
			padding: 4px 16px;
			flex: 1 0 0;
			color: #49454f;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px;
			letter-spacing: 0.5px;
			border-radius: 4px;
			&:focus-visible {
				outline-offset: 0px;
				outline-color: #00438b;
			}
		}
		.switchMode {
			margin-top: 8px;
		}
	}
	@media only screen and (min-width: 900px) and (max-width:1100px) {
		.ranking-action {
			gap: 8px;
		}
	}
	@media only screen and (max-width: 899px) {
		flex-wrap: wrap-reverse;
		justify-content: center;
		gap: 10px;
		.column-div {
			width: 100%
		}
	}
  @media only screen and (max-width: 767px) {
    .ranking {
      &-setting {
        flex-wrap: wrap;
        gap:12px;
      }
    }
    .ranking-players {
      margin-top: 20px;
    }
    .ranking-action {
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 20px;
      justify-content: flex-start;
      .remove {
        font-size: 18px;
        gap: 8px;
      }
      a,
      .save {
        padding: 9px 12px;
        gap: 8px;
        font-size: 18px;
      }
  }
`;

export const ArrowIcon = styled.span`
	transform: ${props => (props.open ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform 0.3s ease;
	svg {
		width: 24px;
		height: 24px;
	}
`;

export const DropdownButton = styled.button`
	display: flex;
	height: 56px;
	justify-content: space-between;
	border-radius: 4px;
	border: 2px solid #00438b;
	background: #e7e9eb;
	padding: 2px 12px;
	justify-content: center;
	align-items: center;
	gap: 20px;
	align-self: stretch;
	color: #000;
	font-size: 36px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	cursor: pointer;
  @media only screen and (max-width: 767px) {
    font-size: 24px;
    padding: 2px 8px;
    gap: 8px;
    height: 48px;
  }
`;
export const Column = styled.div`
    width: 55%;
  
  @media only screen and (max-width: 899px) {
    width: 100%;
  }
  
`;

export const RankPlayersChooseWrapper = styled.div`
	max-width: 590px;
	padding-left: 24px;
	border-left: 1px solid #e8ebef;
	ul {
		li {
			&:not(:last-child) {
				margin-bottom: 16px;
			}
		}
	}
	.numWrapper {
		padding-bottom: 40px;
		border-bottom: 1px solid #d4d4d4;
	}
	.searchPlayer {
		margin: 40px 0;
	}
	.paginationRank {
		margin-top: 25px;
		margin-bottom: 50px;
		ul li {
			padding: inherit;
			margin: inherit;
		}
		.MuiPaginationItem-page {
			font-weight: 400;
			font-size: 14px;
			line-height: 16px;
			color: rgb(14, 17, 24);
			padding: 6px 10px;
			border: 1px solid rgb(152, 158, 164);
			border-radius: 4px;
			margin-right: 6px;
			cursor: pointer;
			&.Mui-selected {
				border: 1px solid rgb(0, 67, 139);
				color: rgb(0, 67, 139);
			}
		}
	}
  @media only screen and (max-width: 899px) {
    width: 100%;
    padding-left:0;  
	  border-left:unset;
	  max-width: unset;
	ul {
		display: flex;
		gap: 25px;
		overflow-x: auto;
		margin-top: 20px;
		li{
			height:200px;
			min-width: 380px;
			display: flex;
			flex-wrap: wrap;
		}
	}
	  .paginationRank {
		  ul  {
			  //display: unset;
			  gap:unset;
			  overflow-x:unset;
			  margin-top: unset;
			  li {
				  height: unset;
				  min-width:unset;
				  display: unset;
				  flex-wrap: unset;
			  }
		  }
	  }
  }
  @media only screen and (min-width: 425px) and (max-width: 767px) {
    .numWrapper {
      padding-bottom: 20px;
    }
    ul {
      display: flex;
      gap: 25px;
      overflow-x: auto;
      margin-top: 20px;
      li{
        min-width: 380px;
        display: flex;
        flex-wrap: wrap;
      }
    }
    .paginationRank {
      ul  {
        display: unset;
        gap:unset;
        overflow-x:unset;
        margin-top: unset;
        li {
          min-width:unset;
          display: unset;
          flex-wrap: unset;
        }
      }
    }
  }
  @media only screen  and (max-width: 424px) {
    .numWrapper {
      padding-bottom: 20px;
    }
    ul {
      display: flex;
      gap: 25px;
      overflow-x: auto;
      margin-top: 20px;

      li {
        min-width: 300px;
        display: flex;
        flex-wrap: wrap;
      }
    }
    .paginationRank {
      ul {
        display: unset;
        gap: unset;
        overflow-x: unset;
        margin-top: unset;

        li {
          min-width: unset;
          display: unset;
          flex-wrap: unset;
        }
      }
    }
  }
`;


// export const DraftPlayerItem = styled.li`
// 	border-bottom: 1px solid #e8ebef;
// 	padding-bottom: 16px;
// 	${props =>
//     props.$disabled &&
//     css`
// 			width: 100%;
// 			pointer-events: none;
// 			opacity: 0.4;
// 			position: relative;
// 			padding: 3px;
// 			background: linear-gradient(90deg, #09c73f 0%, #165874 49.37%, #205997 78.83%, #3769a0 100%);
// 			&:before {
// 				content: '';
// 				position: absolute;
// 				top: 0;
// 				left: 0;
// 				right: 0;
// 				bottom: 0;
// 				z-index: 1;
// 			}
// 			.player-draft {
// 				position: relative;
// 				z-index: 2;
// 				background-color: rgb(231, 233, 235);
// 			}
// 		`}
// 	background-color: ${props => (props.backColor ? `${props.backColor}` : '#fff')};
// 	:first-child {
// 		margin-top: 20px;
// 	}
// 	.player-td {
// 		text-align: center;
// 		width: calc(100% / 8);
// 	}
// 	.player-draft {
// 		padding: 16px;
// 		display: flex;
// 		align-items: center;
// 		gap: 30px;
// 	}
// 	.player-rank,
// 	.player-adp {
// 		p {
// 			font-weight: 400;
// 			font-size: 20px;
// 			line-height: 31px;
// 			color: #46484a;
// 		}
// 		img {
// 			width: 40px;
// 			height: 40px;
// 			object-fit: contain;
// 		}
// 		span {
// 			font-weight: 600;
// 			font-size: 20px;
// 			line-height: 30px;
// 			text-align: center;
// 			color: #000000;
// 		}
// 	}
// 	.player-name {
// 		font-size: 20px;
// 		line-height: 30px;
// 		text-align: center;
// 		color: #004ea3;
// 	}
// 	.player-position {
// 		border: 1px solid #004ea3;
// 		border-radius: 4px;
// 		padding: 5px 16px;
// 		color: #0e1118;
// 	}
// 	.player-college {
// 		font-style: normal;
// 		font-weight: 400;
// 		font-size: 20px;
// 		line-height: 31px;
// 		color: #46484a;
// 	}
// 	@media only screen and (max-width: 1023px) {
// 		.player-draft {
// 			padding: 8px;
// 		}
// 	}
// 	@media ${device.mobileL} {
// 		.player-draft {
// 			gap: 8px;
//             flex-wrap:wrap;
//             justify-content: flex-start;
// 		}
// 		.player-name {
// 			font-size: 18px;
// 			line-height: 22px;
// 			margin-right: 3px;
// 		}
// 		.player-position {
// 			padding: 5px 8px;
// 		}
// 		.player-college {
// 			font-size: 18px;
// 			line-height: 22px;
// 		}
//       .player-td {
//         text-align: center;
//         width: calc(100% / 4);
//       }
// 		//.player-td {
// 		//	width: calc(100% / 6);
// 		//}
// 	}
// 	@media ${device.mobileM} {
// 		.player-draft {
// 			gap: 8px;
// 			flex-wrap:wrap;
// 			justify-content: center;
// 		}
// 		.player-td {
// 			width: calc(100% / 4);
// 		}
// 		.player-name {
// 			font-size: 18px;
// 			line-height: 22px;
// 			margin-right: 3px;
// 			//width: 40%;
// 			//white-space: nowrap;
// 		}
// 		.player-position {
// 			padding: 5px 8px;
// 		}
// 		.player-college {
// 			font-size: 18px;
// 			line-height: 22px;
// 		}
// 		.player-rank{
// 			display: flex;
// 			gap: 4px;
// 		}
// 	}
// 	@media ${device.mobileS} {
// 		.player-draft {
// 			gap: 8px;
// 			flex-wrap:wrap;
// 			justify-content: center;
// 		}
// 		//.player-draft {
// 		//	gap: 8px;
// 		//}
// 		.player-name {
// 			font-size: 18px;
// 			line-height: 22px;
// 			//width: 40%;
// 			//white-space: nowrap;
// 		}
// 		.player-position {
// 			padding: 5px 8px;
// 		}
// 		.player-college {
// 			font-size: 18px;
// 			line-height: 22px;
// 		}
// 		.player-td {
//           width: calc(100% / 3);
// 		}
// 		.player-rank{
// 			display: flex;
// 			gap: 4px;
// 		}
// 	}
// `;

export const DraftPlayerItems = styled.ul`
	width: 100%;
`;
export const DraftPlayerItem = styled.li`
	border-bottom: 1px solid #e8ebef;
	padding-bottom: 16px;
	${props =>
	props.$disabled &&
	css`
			width: 100%;
			pointer-events: none;
			opacity: 0.4;
			position: relative;
			padding: 3px;
			background: linear-gradient(90deg, #09c73f 0%, #165874 49.37%, #205997 78.83%, #3769a0 100%);
			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 1;
			}
			.player-draft {
				position: relative;
				z-index: 2;
				background-color: rgb(231, 233, 235);
			}
		`}
	background-color: ${props => (props.backColor ? `${props.backColor}` : '#fff')};
	:first-child {
		margin-top: 20px;
	}
	.player-td {
		text-align: center;
		//width: calc(100% / 8);
	}
	.player-draft {
		padding: 16px;
		display: flex;
		align-items: center;
		gap: 30px;
	}
	.player-rank{
		width: 10%;
	}
	.player-name{
		width: 25%;
	}
	.player-adp {
		width: 25%;
	}
	.player-position{
		width: fit-content;
		text-align: center;
	}
	.player-rank,
	.player-adp {
		p {
			font-weight: 400;
			font-size: 20px;
			line-height: 31px;
			color: #46484a;
		}
		img {
			width: 40px;
			height: 40px;
			object-fit: contain;
		}
		span {
			font-weight: 600;
			font-size: 20px;
			line-height: 30px;
			text-align: center;
			color: #000000;
		}
	}
	.player-name {
		font-size: 20px;
		line-height: 30px;
		text-align: center;
		color: #004ea3;
	}
	.player-position {
		border: 1px solid #004ea3;
		border-radius: 4px;
		padding: 5px 16px;
		color: #0e1118;
	}
	.player-college {
		font-style: normal;
		font-weight: 400;
		font-size: 20px;
		line-height: 31px;
		color: #46484a;
	}
	@media only screen and (max-width: 1300px) {
		.player-draft {
			gap: 10px;
			flex-wrap: wrap;
			padding: 8px;
		}
	}
	@media only screen and (min-width: 900px)  and (max-width: 1300px) {
		.player-rank{
			width: 20%;
		}
		.player-name{
			width: 45%;
			//white-space: nowrap;
		}
		.player-adp {
			width: 35%;
			white-space: nowrap;
		}
	}

		@media ${device.tablet}{
			.player-draft {
				gap: 8px;
				flex-wrap:wrap;
				justify-content: flex-start;
			}
			.player-name {
				font-size: 18px;
				line-height: 22px;
				margin-right: 3px;
			}
			.player-position {
				padding: 5px 8px;
			}
			.player-college {
				font-size: 18px;
				line-height: 22px;
			}
			.player-td {
				text-align: center;
				width: calc(100% / 4);
			}
		}
	@media ${device.mobileL} {
		.player-draft {
			gap: 8px;
            flex-wrap:wrap;
            justify-content: flex-start;
		}
		.player-name {
			font-size: 18px;
			line-height: 22px;
			margin-right: 3px;
		}
		.player-position {
			padding: 5px 8px;
		}
		.player-college {
			font-size: 18px;
			line-height: 22px;
		}
      .player-td {
        text-align: center;
        width: calc(100% / 4);
      }
	}
	@media ${device.mobileM} {
		.player-draft {
			gap: 8px;
			flex-wrap:wrap;
			justify-content: center;
		}
		.player-td {
			width: calc(100% / 4);
		}
		.player-name {
			font-size: 18px;
			line-height: 22px;
			margin-right: 3px;
			//width: 40%;
			//white-space: nowrap;
		}
		.player-position {
			padding: 5px 8px;
		}
		.player-college {
			font-size: 18px;
			line-height: 22px;
		}
		.player-rank{
			display: flex;
			gap: 4px;
		}
	}
	@media ${device.mobileS} {
		.player-draft {
			gap: 8px;
			flex-wrap:wrap;
			justify-content: center;
		}
		//.player-draft {
		//	gap: 8px;
		//}
		.player-name {
			font-size: 18px;
			line-height: 22px;
			//width: 40%;
			//white-space: nowrap;
		}
		.player-position {
			padding: 5px 8px;
		}
		.player-college {
			font-size: 18px;
			line-height: 22px;
		}
		.player-td {
          width: calc(100% / 3);
		}
		.player-rank{
			display: flex;
			gap: 4px;
		}
	}
	@media only screen and (max-width: 899px) {
		:first-child {
			margin-top: 0
		}
	}
`;